import gql from 'graphql-tag'

export const getTaxQuery = gql`
  query getTaxes(
    $country: String!
    $shipAddress: NetsuiteTaxAddress!
    $cart: [SimpleCartInput]!
    $currency: String
    $isBulkShipAddress: Boolean
    $totalWeight: Float
    $skipExempt: Boolean
  ) {
    taxes: getTaxesByAddress(
      shipAddress: $shipAddress
      countrySubsidiary: $country
      skipExempt: $skipExempt
    ) {
      total
      rate
      ratePst: rate_pst
      rateGst: rate_gst
      internalId
      countrySub
    }

    shipping: getShippingByCountry(
      country: $country,
      cart: $cart,
      currency: $currency,
      isBulkShipAddress: $isBulkShipAddress
      totalWeight: $totalWeight
    ) {
      id
      total
      internalId
      carrier
    }
  }
`

export const isScaPaymentQuery = gql`
  query isScaPayment($code: String!) {
    subsidiarySCA: isScaPayment(code: $code) {
      subsidiary
      sca
    }
  }
`

export const getShippingPrintQuery = gql`
  query getShippingPrint(
    $country: String!
    $cart: [SimpleCartInput]!
    $currency: String
  ) {
    shipping: getShippingByCountry(country: $country, cart: $cart, printOrder: true, currency: $currency) {
      id
      total
      internalId
      carrier
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Checkout/CheckoutSummary/data.ts